<app-dci-filter [inputFields]="obj" (valueChange)='receviewData($event)' [hidden]="!ShowSearch"></app-dci-filter>
<div [ngClass]="{'kgrid-fullscreen' : enableFullscreen}">
    <kendo-grid [kendoGridBinding]="finalDrawingList" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [reorderable]="true" [pageSize]="15" [filterable]="false" [pageable]="true" id="grvEDMOrgList" [height]="540">
        <ng-template kendoPagerTemplate>
            <div class="k-pager-left">
                <kendo-pager-info></kendo-pager-info>
            </div>
            <div class="k-pager-right">
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-input></kendo-pager-input>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>
            </div>
            <ng-template kendoGridToolbarTemplate>
                <div class="k-grid-toolbar-content d-flex justify-content-end">
                    <div class="icons-container">
                        <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">

                            <div class="icon-wrap">
                                <i class="fa fa-search" title="Search Filter" (click)="toggleShowSearch()" aria-hidden="true"></i>
                                <span class="list-icon-name">Search Filter</span>
                            </div>
                        </div>
                    </div>
                    <div class="divider-container d-none d-md-block" id="imgDivider">
                        <span></span>
                    </div>
                    <div class="pagination-container">
                        <p id="lblShowDetails">Show</p>
                        <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                        </kendo-pager-page-sizes>
                        <span>Items</span>
                    </div>
                    <div class="divider-container d-none d-md-block" id="imgDivider">
                        <span></span>
                    </div>
                    <div class="icons-container d-flex justify-content-end">
                        <div class="icon-wrap">
                            <button type="button" class="btn btn-primary eip-ml-20 eip-mr-20" style="background: #1579ab;padding: 5px;" kendoGridExcelCommand icon="file-excel">Export to Excel</button>
                        </div>
                        <div class="icon-wrap">
                            <i class="fa fa-filter" style="float: right;" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                        </div>
                        <div class="icon-wrap" (click)="toggleFullscreen()">
                            <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ng-template>
        <kendo-grid-column title="Sl.No." [width]="40">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                {{rowIndex + 1}}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Document No" field="doc_No" [width]="150">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.doc_No}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.doc_No}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Title" field="doc_Title" [width]="200">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.doc_Title}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.doc_Title}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Revision" field="revision_No" [width]="40">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.revision_No}}" eipTooltipPosition="auto">{{dataItem.revision_No}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Print Size" field="print_Size" [width]="40">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.print_Size}}" eipTooltipPosition="auto">{{dataItem.print_Size}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Scheduled On" field="scheduled_On" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.scheduled_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.scheduled_On | date:'dd-MMM-yyyy'}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Submitted On" field="submitted_On" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.submitted_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.submitted_On | date:'dd-MMM-yyyy'}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Completed On" field="completed_On" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.completed_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.completed_On | date:'dd-MMM-yyyy'}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Transmittal Nos" field="comment_Sheet_No" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.comment_Sheet_No}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.comment_Sheet_No}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Final Drawing" width="50">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <i class="fa fa-paperclip eip-link" style="font-size: 1.25em; cursor: pointer;" aria-hidden="true" (click)="openAttachmentFileList(dataItem,5)"></i>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="CAD" *ngIf="!isCLient" width="50">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <i class="fa fa-paperclip eip-link" style="font-size: 1.25em; cursor: pointer;" aria-hidden="true" (click)="openAttachmentFileList(dataItem,1)"></i>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-excel fileName="FinalDrawing.xlsx" [fetchData]="allData"></kendo-grid-excel>
    </kendo-grid>
</div>